import RegisterForm from './RegisterForm.jsx';

export {RegisterForm}



// WEBPACK FOOTER //
// ./components/register/index.js